
<div class="nsw-hero-banner nsw-hero-banner--dark nsw-hero-banner--wide nsw-hero-banner--beachwatch">
	<div class="nsw-hero-banner__container">
	  <div class="nsw-hero-banner__wrapper">
		<div class="nsw-hero-banner__content banner-content" >
		  	<h1>Monitoring water quality for swimming in New South Wales</h1>
		  	<p class="nsw-intro">Working with partners to monitor ocean beaches, estuaries and inland waterways so you can make safer choices on where and when to swim.</p>		  
		</div>		
	  </div>
	</div>
</div>
